import cn from 'bem-cn';

import {
    LikesCounter,
    Stack,
    // ViewsCounter
} from '../../UI';
import { BackButton } from '../../BackButton/BackButton';

import { PromptInfoStatisticsProps } from './PromptInfoStatistics.types';
import './PromptInfoStatistics.scss';

const b = cn('prompt-info-statistics');

export const PromptInfoStatistics = (props: PromptInfoStatisticsProps) => {
    const {
        className,
        likes = 0,
        isLiked = false,
        // views = 0,
        countersDirection = 'row',
        onLikeClick,
    } = props;

    return (
        <Stack className={b.mix(className)}>
            <BackButton />
            <LikesCounter direction={countersDirection} likes={likes} isLiked={isLiked} onClick={onLikeClick} />
            {/* <Divider orientation="vertical" />
            <ViewsCounter direction={`${countersDirection}-reverse`} views={views} /> */}
        </Stack>
    );
};
